module.exports = __webpack_public_path__ + "img/avatar_real_2.8da87f0a.jpg";